// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ovr1","badges":"styles_badges__2GAnp"};